import { put } from 'redux-saga/effects';
import { errorHandler } from 'src/errorHandler/errorHandler';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';
import {
    GET_PRODUCTS_BY_BRAND_OR_SUPERCATEGORY_SUCCESS,
    GET_PRODUCTS_BY_BRAND_OR_SUPERCATEGORY_FAILURE,
} from '../actions/actionTypes';
import { convertObjectToQueryParams } from 'src/utils/util';
import { getconsignmentAddProductsByBrandOrSuperCategoryDataService } from '../../services';


export default function* getconsignmentAddProductsByBrandOrSuperCategory(action) {
    try {
        let result = yield getconsignmentAddProductsByBrandOrSuperCategoryDataService(convertObjectToQueryParams({
            ...action.payload,
        }));
        let updatedData = {};
        let brandRefineData = [];
        if (result?.subCategoryRefineData) {
            updatedData = result?.subCategoryRefineData?.map((cat) => {
                return {
                    ...cat,
                    classificationRefineData: cat?.classificationRefineData.map(
                        (item) => {
                            return {
                                ...item,
                                isChecked: item.selected
                                    ? item.selected
                                    : false,
                            };
                        }
                    ),
                };
            });
        }
        //added these function for brand filter
        if (result?.brandRefineData) {
            brandRefineData = result.brandRefineData?.map((item) => {
                return {
                    ...item,
                    isChecked: item.selected ? item.selected : false,
                };
            });
        }
        //added these function for brand filter
        if (result?.brandRefineData?.length > 0) {
            result.brandRefineData = brandRefineData;
        }

        if (result?.subCategoryRefineData?.length > 0) {
            result.subCategoryRefineData = updatedData;
        }
        yield put({
            type: GET_PRODUCTS_BY_BRAND_OR_SUPERCATEGORY_SUCCESS,
            productGuideData: result,
        });
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: `/occ/v2/${localStorage.getItem('baseSiteId')}/products/productDetailsByFacetCategoryBrand`,
            requestPayload: action.payload
        });
        yield put({
            type: GET_PRODUCTS_BY_BRAND_OR_SUPERCATEGORY_FAILURE,
            templateError: errorHandler('503'),
        });
    }
}
